import { PageLoadError } from '@components/page-load-error';
import { getAccountsQueryOptions, getTransferSetsQueryOptions, } from '@features/accounts/api';
import { TransferDetailsCardProps } from '@features/transfers/components';
import { TransferSetState, TransferType } from '@features/transfers/enums';
import { Transfer } from '@features/transfers/types';
import { createFileRoute } from '@tanstack/react-router';
import { formatDate } from '@utils';
import InProgressLayout from './-layouts/in-progress-layout';

type TransferDetailsData = {
  uuid: string;
  transferType: TransferType;
  state: TransferSetState;
  transferDetailsCardProps: TransferDetailsCardProps[];
};

export const Route = createFileRoute('/_authenticated/transfers/in-progress')({
  component: InProgressLayout,
  errorComponent: ({ error }) => (
    <PageLoadError pageName='In Progress' error={error} />
  ),
  loader: async ({
    context,
  }): Promise<{
    transferDetails: TransferDetailsData[];
  }> => {
    let transferDetails: TransferDetailsData[] = [];

    const results = await Promise.allSettled([
      context.queryClient.ensureQueryData(getAccountsQueryOptions),
      context.queryClient.ensureQueryData(getTransferSetsQueryOptions),
    ]);
    const [accounts, transferSets] = results;
    if (
      accounts?.status === 'fulfilled' &&
      transferSets.status === 'fulfilled'
    ) {
      transferDetails = transferSets.value.transferSets.map((set) => {
        const details = set.transfers.map((transfer: Transfer) => {
          const source = accounts.value.all.find(
            (acc) => acc.uuid === transfer.sourceAccountUuid,
          )?.name;

          const destination = accounts.value.all.find(
            (acc) => acc.uuid === transfer.destinationAccountUuid,
          )?.name;

          const props: TransferDetailsCardProps = {
            uuid: transfer.uuid,
            source: source ?? transfer.sourceAccountUuid,
            destination: destination ?? transfer.destinationAccountUuid,
            amount: transfer.amountCents,
            createdAt: formatDate({
              date: transfer.createdAt,
              includeTime: true,
            }),
            transferStatus: transfer.state,
          };

          return props;
        });

        return {
          uuid: set.uuid,
          state: set.state,
          transferType: set.type,
          transferDetailsCardProps: details,
        };
      });
    }

    return { transferDetails };
  },
});
